/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  /* Reduce motion flag */
  @media (prefers-reduced-motion: reduce) {
    button {
      animation: none;
    }
  }
`;
